<script setup>
import { reactive, ref } from "vue";
import { FormModal } from "@Components/Modal";
import { FormInput, FormLabel } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { ArrowRightIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { getVideoIdFromUrl, getVideoTitleFromUrl } from "@Utils/youtube";

const emit = defineEmits(["submit"]);

const { t: __ } = useI18n();

const modal = ref();

const form = reactive({
    url: "",
});
const processing = ref(false);

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

const search = async () => {
    if (form.url.length === 0) {
        return;
    }

    processing.value = true;

    let title = await getVideoTitleFromUrl(form.url);
    if (title === undefined) {
        processing.value = false;
        return;
    }

    title = title.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, "");
    title = title.trim();

    if (title.length === 0) {
        processing.value = false;
        return;
    }

    emit("submit", {
        title: title,
        url: form.url,
        videoId: getVideoIdFromUrl(form.url),
    });

    processing.value = false;
    hide();
};

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" :title="__('YouTube')">
        <template #body>
            <form @submit.prevent="search">
                <FormLabel for="youtube-source-url">{{ __("URL de la vidéo YouTube") }}</FormLabel>
                <div class="flex justify-center gap-3 mt-2">
                    <div class="flex-1">
                        <FormInput id="youtube-source-url" v-model="form.url" :placeholder="`https://www.youtube.com/watch?v=dQw4w9WgXcQ`" :z="1" />
                    </div>
                    <div class="mt-[2px] flex-none">
                        <PrimaryButton type="submit" :processing="processing" :icon="ArrowRightIcon" :z="1" />
                    </div>
                </div>
            </form>
        </template>
    </FormModal>
</template>
